module.exports = __webpack_public_path__ + "static/media/video-guilt-en.4195c2bc.vtt";